import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage, injectIntl } from 'react-intl';

import {
  COMMON,
  COMMUNITY_ACTIVITY_REQUEST,
} from '../../../../constants/strings';
import Button from '../../../Button';
import { CommunityCard } from '../CommunityCard';
import { TimeShow } from '../../../common/TimeShow';
import { IDS } from '../../../../constants/ids';
import styl from './index.styl';

const ActivityListItem = ({
  logo,
  name,
  userName,
  subtitle,
  onClick,
  createdAt,
  onHandleJoinRequest,
  organizations,
  intl: { formatMessage },
  id,
  communityId,
  role,
  disabled,
  requestId,
}) => (
  <CommunityCard
    avatar={{
      src: logo,
      size: 100,
      name,
    }}
    renderTitle={() => (
      <div className="pointer" onClick={() => onClick(id, 'profile')}>
        {name} <span className="fw4 g-color--accent">{userName}</span>
      </div>
    )}
    renderSubTitle={() => (
      <p>
        {!!role && <span>{role} &bull; </span>}
        {organizations}
      </p>
    )}
    renderContent={() => (
      <FormattedMessage
        {...COMMUNITY_ACTIVITY_REQUEST}
        values={{
          communityName: (
            <span
              onClick={() => onClick(communityId, 'community')}
              className="g-color--info fw6 pointer"
            >
              {subtitle}
            </span>
          ),
        }}
      />
    )}
    renderInfo={() => <TimeShow timestamp={createdAt} />}
    renderActions={() => (
      <Fragment>
        <Button
          id={IDS.ACTIVITIES.JOIN_REQUEST_ACCEPT_BTN}
          disabled={disabled}
          color="primary"
          className="mb1"
          onClick={() => onHandleJoinRequest(requestId, 'accept')}
        >
          {formatMessage(COMMON.accept)}
        </Button>
        <Button
          id={IDS.ACTIVITIES.JOIN_REQUEST_DECLINE_BTN}
          disabled={disabled}
          color="accent"
          onClick={() => onHandleJoinRequest(requestId, 'decline')}
        >
          {formatMessage(COMMON.decline)}
        </Button>
      </Fragment>
    )}
  />
);

ActivityListItem.propTypes = {
  createdAt: PropTypes.string,
  logo: PropTypes.string,
  name: PropTypes.string,
  userName: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  onHandleJoinRequest: PropTypes.func,
  organizations: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  id: PropTypes.number.isRequired,
  communityId: PropTypes.number,
  role: PropTypes.string,
  disabled: PropTypes.bool,
  requestId: PropTypes.number.isRequired,
};

ActivityListItem.defaultProps = {
  createdAt: '',
  logo: '',
  name: '',
  userName: '',
  subtitle: '',
  onClick: null,
  onHandleJoinRequest: null,
  organizations: '',
  communityId: null,
  role: '',
  disabled: null,
};

export default injectIntl(
  CSSModules(ActivityListItem, styl, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/Components/ActivitiesList/ActivityListItem.jsx